/**
 * The S1 credential warning at first contact (redesign spec §2.1).
 *
 * The full sentence, in the `shell__notice` strip styling the chrome used to
 * own — rendered by the entry and sign-in surfaces themselves now, because a
 * warning on every page is a warning nobody reads on the page that matters.
 * The wizard's free-text screens carry the compact `SectionNotice` instead.
 */
import type { JSX } from 'react'

import { t } from './i18n.ts'

export function FirstContactNotice(): JSX.Element {
  return (
    <aside className="shell__notice" role="note">
      <div className="shell__notice-inner">
        <span className="shell__chip shell__chip--caution">{t('secrets.badge')}</span>
        <p className="shell__notice-text">
          <strong>{t('secrets.heading')}</strong> {t('secrets.body')}
        </p>
      </div>
    </aside>
  )
}
